import EventEmitter from 'events'

import store from '@/store/index'

class AuthService extends EventEmitter {
  logOut() {
    store.dispatch('auth/logout')
  }

  isAuthenticated() {
    return store.getters['auth/isAuthenticated']
  }

  /**
   * Get the current access token
   * @returns {string}
   */
  getToken() {
    store.dispatch('auth/logoutIfNotAuthenticated')
    return store.state.auth.accessToken
  }

  isGodAdmin() {
    return store.getters['auth/isGodAdmin']
  }
}

export default new AuthService()
